import { render, staticRenderFns } from "./partner-clinic.vue?vue&type=template&id=3d455066&"
import script from "./partner-clinic.vue?vue&type=script&lang=js&"
export * from "./partner-clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports